import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from '_atoms';
import { CreatePromotionRequestButton } from '_molecules';
import { NewOpenings, PromotionRequestsTable, SelfSubmittedCandidatesDashboard } from '_organisms';
import { getPromotionRequestsOnDashboardRecruiter } from 'actions';
import { useQuery } from 'helpers/useLocation';
import { MyActiveCandidates } from '../DashboardHRLead/DashboardHRLead';
import { TABS } from './constants';
import './style.scss';

export const DashboardRecruiter: React.FC = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const [tab, setTab] = useState((query.tab as string) || TABS[0].key);
  const tabs = TABS.map(item => ({ ...item, label: t(item.label) }));

  return (
    <div className="dashboard-recruiter">
      <div className="dashboard-recruiter__banner-wrapper">
        <div className="top-banner" />
        <NewOpenings />
      </div>
      <Tabs className="dashboard-recruiter__tabs" activeTab={tab} onChange={setTab} items={tabs} />
      {
        {
          [TABS[0].key]: <MyActiveCandidates recruiterDashboard setTabsLoading={() => {}} />,
          [TABS[1].key]: <SelfSubmittedCandidatesDashboard dashboard="recruiter" />,
          [TABS[2].key]: (
            <PromotionRequestsTable
              fetchRequests={getPromotionRequestsOnDashboardRecruiter}
              cardTitle={t('translation:dashboard_recruiter.tab_promotion_requests')}
              extra={<CreatePromotionRequestButton />}
            />
          ),
        }[tab]
      }
    </div>
  );
};
